package org.gymly.ui.admin

import org.gymly.model.AdminDivisasConversion
import org.gymly.model.AdminExchangeRateQuote
import kotlin.math.roundToLong

fun convertDivisasLocally(usdCents: Long, quote: AdminExchangeRateQuote): AdminDivisasConversion? {
    if (usdCents <= 0) return null
    val eurRate = quote.eurRate ?: return null
    val usdRate = quote.usdRate ?: return null
    val usdAmount = usdCents / 100.0
    val eurAmount = usdAmount * usdRate / eurRate
    val vesAmount = if (quote.divisasUsesEurRate) usdAmount * eurRate else usdAmount * usdRate
    return AdminDivisasConversion(
        usdCents = usdCents,
        eurCents = (eurAmount * 100.0).roundToLong(),
        vesCents = (vesAmount * 100.0).roundToLong(),
        eurRate = eurRate,
        usdRate = usdRate,
        effectiveDate = quote.effectiveDate,
    )
}

fun formatExchangeRate(value: Double?): String {
    if (value == null) return "—"
    val raw = value.toString()
    return if (raw.contains('.')) raw.trimEnd('0').trimEnd('.') else raw
}

fun divisasLineAmountCents(line: PaymentLineDraft, defaultAmount: String, quote: AdminExchangeRateQuote?): Long =
    foreignCurrencyLineAmountCents(line, defaultAmount, quote)

fun divisasLineUsdCents(line: PaymentLineDraft, defaultAmount: String, quote: AdminExchangeRateQuote?): Long? =
    foreignCurrencyLineUsdCents(line, defaultAmount, quote)

fun PaymentLineDraft.toCollectLine(defaultAmount: String, quote: AdminExchangeRateQuote?): org.gymly.model.AdminPaymentCollectLine {
    val sanitized = sanitizePaymentLineForMethod()
    val usdCents = foreignCurrencyLineUsdCents(sanitized, defaultAmount, quote)
    val amountCents = if (sanitized.method.usesUsdAmount()) {
        0L
    } else {
        sanitized.amountCents(defaultAmount)
    }
    val ref = normalizePaymentReference(method, notes)
    return org.gymly.model.AdminPaymentCollectLine(
        method = sanitized.method,
        amountCents = amountCents,
        foreignUsdCents = usdCents,
        payerPhone = null,
        notes = ref.ifBlank { null },
    )
}

/** Efectivo / móvil / transferencia: solo Bs. Zelle / USDT / Divisas: solo USD (sin Bs en la línea). */
fun PaymentLineDraft.sanitizePaymentLineForMethod(): PaymentLineDraft = copy(vesAmountInput = "")
